import React from 'react';
import type EditPermissionSchemePageType from '@atlassian/jira-edit-permission-scheme/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyEditPermissionSchemePage = lazyForPaint<typeof EditPermissionSchemePageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-edit-permission-scheme", jiraSpaEntry: "async-jira-edit-permission-scheme" */ '@atlassian/jira-edit-permission-scheme'
		),
	),
);

const AsyncEditPermissionSchemePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyEditPermissionSchemePage}
		pageId="jira-edit-permission-scheme"
		shouldShowSpinner
	/>
);

export default AsyncEditPermissionSchemePage;
